// A users doc that grants access to something. Mirrored by isKnownUser() in
// astrid-firebase/src/rules/firestore.legacy.rules; users can't set these fields on themselves.
export default function isKnownUser(user) {
	const permissions = user?.permissions || {};

	return (
		["admin", "owner"].includes(permissions.role) ||
		Object.keys(user?.organizations || {}).length > 0 ||
		Object.keys(permissions.producer || {}).length > 0 ||
		Object.keys(permissions.publisher || {}).length > 0 ||
		(Array.isArray(permissions.reader) && permissions.reader.length > 0) ||
		permissions.storytoolArchive?.enableArchiveAccess === true
	);
}
